import Grid from "@material-ui/core/Grid";
import { useDialog } from "muibox";
import { DataProvider } from "ra-core";
import { useCallback, useEffect } from "react";
import { useDataProvider } from "react-admin";
import { TS_AND_CS_KEY, TS_AND_CS_VERSION } from "../constants";
import CustomTitle from "../reusable-components/layout/CustomTitle";
import useUserContext from "../shared/useUserContext";
import { localStorageService } from "../shared/util/LocalStorageService";
import Footer from "./Footer";
import windBackgroundJpg from "./images/wind-background.jpg";
import { portalLinkOM } from "./links";
import OMMainFeaturedPost from "./OMMainFeaturedPost";
import { confirmTsAndCs } from "./TermsAndConditions";

export default function OMDashboard() {
  const dataProvider: DataProvider = useDataProvider();
  const dialog = useDialog();
  const userContext = useUserContext();

  const recordTsAndCsAccepted = useCallback(() => {
    // we store this with the browser against the user or guest depending on the context
    if (userContext.isGuest) {
      localStorageService.setItem<string>(
        `${TS_AND_CS_KEY}.guest`,
        TS_AND_CS_VERSION
      );
    } else {
      localStorageService.setItem<string>(
        `${TS_AND_CS_KEY}.${userContext.email}`,
        TS_AND_CS_VERSION
      );
    }

    // and against the user on the server
    dataProvider
      .acceptTsAndCs(TS_AND_CS_VERSION)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [dataProvider, userContext]);

  const acceptTsAndCs = useCallback(async () => {
    (await confirmTsAndCs(dialog, true)) && recordTsAndCsAccepted();
  }, [dialog, recordTsAndCsAccepted]);

  useEffect(() => {
    async function requestTsAndCsAcceptance() {
      await acceptTsAndCs()
        .then(() => {})
        .catch(() => undefined);
    }
    const { acceptedTsAndCs, isGuest } = userContext;
    if (!isGuest && !acceptedTsAndCs) {
      requestTsAndCsAcceptance();
    }
  }, [acceptTsAndCs, userContext]);

  return (
    <>
      <Grid>
        <CustomTitle title="omApp.title.customerPortal"></CustomTitle>
        <OMMainFeaturedPost
          post={{
            title: "",
            imageUrl: windBackgroundJpg,
            imageText:
              "Operations Customer Portal - Manapouri Background Photo",
            overlayHeight: "75vh",
            content: `"## AUFLS`,
            featuredApp: {
              shortName: "OM",
              title: "Outage Management (OM)",
              content: `The Outage Management app provides information related to the
                  Detailed Outage Requirements affecting your organisation.<br />Use this application to review and respond to the Detailed
                  Outage Requirements.`,
              imageText: "OM application",
              appLink: portalLinkOM,
            },
          }}
        />
        <Grid
          container
          style={{
            display: "flex",
            width: "20%",
            marginLeft: "40%",
            marginRight: "40%",
          }}
          spacing={4}
        ></Grid>

        <Footer isOMApp={true} />
      </Grid>
    </>
  );
}
